import { useEffect, useState } from "react"
import { Navigate, useLocation } from "react-router-dom"
import axios from "../utils/axios"

export default function RequireOnboarding({ children }) {
  const [status, setStatus] = useState("loading")
  const location = useLocation()

  useEffect(() => {
    const token = localStorage.getItem("access_token")
    if (!token) {
      setStatus("unauthenticated")
      return
    }

    axios
      .get("/api/onboarding/")
      .then((res) => {
        setStatus(res.data?.needs_onboarding ? "needs_onboarding" : "ok")
      })
      .catch(() => setStatus("unauthenticated"))
  }, [location.pathname])

  if (status === "loading") {
    return null
  }
  if (status === "unauthenticated") {
    return <Navigate to="/login" replace />
  }
  if (status === "needs_onboarding") {
    return <Navigate to="/onboarding" replace />
  }
  return children
}
